module.exports = __webpack_public_path__ + "static/media/img100.091268a1.png";